import React, { useEffect, useState } from "react";
import styles from "./QuickViewCard.module.scss";
import { indicatorList } from "Explore/Config/FilterConfig";

// ---------- helpers ----------
const fmt = (num) => {
  if (num == null) return "—";
  if (Math.abs(num) >= 1e9) return (num / 1e9).toFixed(1) + "B";
  if (Math.abs(num) >= 1e6) return (num / 1e6).toFixed(1) + "M";
  if (Math.abs(num) >= 1e3) return Math.round(num / 1e3) + "K";
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};

const getAbbreviation = (name) => {
  const words = name.split(/[\s,]+/).filter(Boolean);
  // Common abbreviations
  const skip = new Set(["of", "the", "at", "and"]);
  return words
    .filter((w) => !skip.has(w.toLowerCase()))
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 4);
};

const InstitutionLogo = ({ photoUrl, fallbackText }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [photoUrl]);
  if (photoUrl && !failed) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={styles["quick-card__logo-img"]}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <div className={styles["quick-card__logo"]}>{fallbackText}</div>
  );
};

const indicatorLabelMap = indicatorList.reduce((acc, indicator) => {
  acc[indicator.value] = indicator.label;
  return acc;
}, {});

const indicatorUnitMap = {
  international_collaborations: "collabs",
};

const getIndicatorValue = (indicators, indicator) => {
  const value = indicators?.[indicator];
  if (
    indicator === "international_collaborations" &&
    value &&
    typeof value === "object"
  ) {
    return value.total_collaborations ?? 0;
  }
  return value;
};

const QuickViewCard = ({
  data,
  rank,
  maxCitations,
  selectedIndicators = [],
  isSelected,
  onToggle,
}) => {
  const { institution_name, institution_id, institution_photo_url, indicators } =
    data;
  const abbr = getAbbreviation(institution_name);
  const indicatorsToShow = selectedIndicators.length
    ? selectedIndicators
    : ["total_publications"];

  const citationRatio = maxCitations > 0
    ? (indicators.total_citations || 0) / maxCitations
    : 0;

  return (
    <div className={styles["quick-card"]}>
      {/* CHECKBOX */}
      <div className={styles["quick-card__checkbox"]}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onToggle}
        />
      </div>

      {/* LEFT — rank */}
      {/* <div className={styles["quick-card__left"]}>
        <div className={styles["quick-card__rank"]}>#{rank}</div>
      </div> */}

      {/* CENTER — info */}
      <div className={styles["quick-card__center"]}>
        <div className={styles["quick-card__header"]}>
          <div className={styles["quick-card__name-block"]}>
            <InstitutionLogo
              photoUrl={institution_photo_url}
              fallbackText={abbr.slice(0, 2)}
            />
            <div className={styles["quick-card__title"]}>
              <span className={styles["quick-card__full-name"]}>
                {institution_name}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["quick-card__right"]}>
        <div className={styles["quick-card__metrics"]}>
          {indicatorsToShow.map((indicator) => (
            <div className={styles["quick-card__metric"]} key={indicator}>
              <span className={styles["quick-card__metric-label"]}>
                {indicatorLabelMap[indicator] || indicator}
              </span>
              <span className={styles["quick-card__metric-value"]}>
                {fmt(getIndicatorValue(indicators, indicator))}
                {!!indicatorUnitMap[indicator] && (
                  <sub>{indicatorUnitMap[indicator]}</sub>
                )}
              </span>
            </div>
          ))}
        </div>

        <div className={styles["quick-card__bar-section"]}>
          <div className={styles["quick-card__bar-labels"]}>
            <span>Citations</span>
            <span>cormax {fmt(indicators.total_citations)}</span>
          </div>
          <div className={styles["quick-card__bar"]}>
            <div
              className={styles["quick-card__bar-fill"]}
              style={{ width: `${Math.round(citationRatio * 100)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickViewCard;
